import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const handled = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    api
      .post("/auth/google/session", { session_id })
      .then((r) => {
        setUser(r.data);
        const u = r.data || {};
        const needsProfile =
          u.role === "doctor" && (!(u.specialty || "").trim() || !(u.whatsapp || "").trim());
        const next = needsProfile ? "/complete-profile" : "/dashboard";
        window.history.replaceState({}, "", next);
        navigate(next, { replace: true });
      })
      .catch(() => {
        setError("Could not complete Google sign-in. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 2000);
      });
    // `api` is a stable module-level singleton; `handled` is a ref; `setError`/`setUser` are
    // setState setters — all stable across renders. Only navigation triggers should re-run.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] grid place-items-center px-6">
      <div className="text-center">
        <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
          Establishing session…
        </div>
        {error && <p className="text-sm text-destructive mt-3">{error}</p>}
      </div>
    </div>
  );
}
